export const capitalize = (phrase?: string) =>
  phrase
    ?.split(/\s+/)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    .join(' ') ?? '';
